import React, { useState } from 'react';
import './style.css';

const ImagePicker = ({ image, handleInputChange }) => {
  const [selectedImage, setSelectedImage] = useState(image);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      handleInputChange(file); // Pass the file object to the parent component
    }
  };

  return (
    <div className="image-picker" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <label htmlFor="file-upload" className="image-container">
        {selectedImage ? (
          <img src={selectedImage} alt="Selected" />
        ) : (
          <div className="flex items-center flex-col h-auto">
              <i className="pi pi-image mt-3 p-5" style={{ fontSize: '1.5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
              <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                  Upload image
              </span>
          </div>
        )}
        {isHovered && (
          <div className="overlay">
            <button className="change-button">Change</button>
          </div>
        )}
      </label>
      <input 
        type="file" 
        id="file-upload" 
        accept="image/*" 
        onChange={handleChange} 
        className="file-input"
      />
    </div>
  );
};

export default ImagePicker;
